/** 远程 Select 的空选项只在输入了搜索词后才作为有效结果反馈给用户。 */
export function shouldSuppressSelectEmpty(
    componentName: string | undefined,
    searchInput: HTMLInputElement | null
): boolean {
    return (
        componentName === "Select" &&
        searchInput?.classList.contains("ant-select-selection-search-input") === true &&
        !searchInput.value.trim()
    );
}
